import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Badge, Empty } from "@/components/admin/Ui";
import {
  UsersThree, EnvelopeSimple, ChatCircleDots, FileText, UsersFour,
  Sparkle, ChatsCircle, Lightning,
} from "@phosphor-icons/react";

const TYPE_META = (t) => {
  if (t.startsWith("agent_")) return { icon: Sparkle, tone: t.includes("error") ? "red" : "ember", label: "AGENT RUN" };
  if (t === "lead_created") return { icon: UsersThree, tone: "neutral", label: "LEAD CREATED" };
  if (t.startsWith("outreach_sent")) return { icon: EnvelopeSimple, tone: "green", label: "EMAIL SENT" };
  if (t.startsWith("outreach_")) return { icon: EnvelopeSimple, tone: "amber", label: "DRAFT" };
  if (t.startsWith("reply_interested")) return { icon: ChatCircleDots, tone: "green", label: "REPLY · INTERESTED" };
  if (t.startsWith("reply_")) return { icon: ChatCircleDots, tone: "neutral", label: "REPLY" };
  if (t.startsWith("application_approved")) return { icon: FileText, tone: "green", label: "APPLICATION APPROVED" };
  if (t.startsWith("application_")) return { icon: FileText, tone: "amber", label: "APPLICATION" };
  if (t === "member_onboarded") return { icon: UsersFour, tone: "green", label: "MEMBER ONBOARDED" };
  if (t.startsWith("chatbot_session_lead")) return { icon: ChatsCircle, tone: "green", label: "CHATBOT · LEAD" };
  if (t.startsWith("chatbot_")) return { icon: ChatsCircle, tone: "neutral", label: "CHATBOT" };
  return { icon: Lightning, tone: "neutral", label: t.toUpperCase() };
};

const filtersFor = (t, filter) => {
  if (filter === "all") return true;
  if (filter === "outreach") return t.startsWith("outreach");
  if (filter === "replies") return t.startsWith("reply");
  if (filter === "applications") return t.startsWith("application");
  if (filter === "members") return t === "member_onboarded";
  if (filter === "leads") return t === "lead_created";
  if (filter === "chatbot") return t.startsWith("chatbot");
  if (filter === "agents") return t.startsWith("agent");
  return true;
};

export default function Activity() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/activity");
    setEvents(data.events || []);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const filtered = events.filter((e) => filtersFor(e.type || "", filter));

  return (
    <div data-testid="admin-activity-page">
      <PageHeader title="Live activity feed" subtitle="Operations · last 80 events" action={
        <button onClick={load} data-testid="activity-refresh" className="btn-secondary !py-2 !px-3 text-sm">Refresh</button>
      } />
      <div className="p-8 space-y-4">
        <div className="flex flex-wrap gap-2">
          {["all", "leads", "outreach", "replies", "applications", "members", "chatbot", "agents"].map((f) => (
            <button
              key={f}
              data-testid={`activity-filter-${f}`}
              onClick={() => setFilter(f)}
              className={`text-xs uppercase tracking-widest px-3 py-1.5 border transition-colors ${
                filter === f ? "bg-navy text-white border-navy" : "bg-white text-navy/70 border-black/15 hover:border-navy"
              }`}
            >{f}</button>
          ))}
        </div>

        {loading ? <div className="text-navy/60">Loading…</div> :
         filtered.length === 0 ? <Empty label="No events match this filter yet." /> : (
          <div className="bg-white border border-black/10 divide-y divide-black/5">
            {filtered.map((e, i) => {
              const m = TYPE_META(e.type || "");
              const Icon = m.icon;
              return (
                <div key={i} className="px-5 py-3 flex items-start gap-4" data-testid={`activity-row-${i}`}>
                  <div className="mt-0.5"><Icon size={18} weight="duotone" className="text-ember" /></div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <Badge tone={m.tone}>{m.label}</Badge>
                      <span className="font-medium text-navy truncate">{e.title || "—"}</span>
                    </div>
                    <div className="text-xs text-navy/60 mt-0.5">{e.subtitle || ""}</div>
                  </div>
                  <div className="text-[10px] uppercase tracking-widest text-navy/40 shrink-0">{new Date(e.ts).toLocaleString()}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
